import { render, staticRenderFns } from "./RowsTable.vue?vue&type=template&id=268db3fb"
import script from "./RowsTable.vue?vue&type=script&lang=js"
export * from "./RowsTable.vue?vue&type=script&lang=js"
import style0 from "./RowsTable.vue?vue&type=style&index=0&id=268db3fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports